export default __webpack_public_path__ + "static/media/quote.d29d0456.svg";